import { detailsBig } from "@/styles/typography";
import styled from "styled-components";

const Container = styled.a<{ color: string }>`
  color: ${({ color }) => color};
  display: flex;
  align-self: flex-start;
  text-align: left;
  align-items: center;
  text-decoration: none;
  gap: 26px;

  white-space: nowrap;
  height: 100%;
  transition: all 0.2s ease-in-out;

  img {
    height: 18px;
    transition: all 0.2s ease-in-out;
  }
  @media ${({ theme }) => theme.breakpoints.hover} {
    &:hover {
      img {
        transform: translateX(30px);
      }
      
      filter: ${({ theme }) => theme.filter.gold};
    }
  }

  @media ${({ theme }) => theme.breakpoints.sm} {
    margin: 20px 0;
  }
`;
const NoAContainer = styled.div<{ color: string }>`
  color: ${({ color }) => color};
  display: flex;
  align-self: flex-start;
  text-align: left;
  align-items: center;
  text-decoration: none;
  gap: 26px;
  white-space: nowrap;
  height: 100%;
  transition: all 0.2s ease-in-out;

  @media ${({ theme }) => theme.breakpoints.hover} {
    &:hover {
      gap: 56px;
    }
  }
  @media ${({ theme }) => theme.breakpoints.sm} {
    margin: 20px 0;
  }
`;

const Title = styled(detailsBig)<{ color: string }>`
  color: ${({ color }) => color};
  text-transform: uppercase;
  font-size: 22px;

  @media ${({ theme }) => theme.breakpoints.sm} {
    font-size: 18px;
  }
`;

const S = {
  Container,
  NoAContainer,
  Title,
};

export default S;
